module.exports = __webpack_public_path__ + "img/i_new_in_badge.548fa50f.svg";